import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import "../../../assests/css/students/Principal/PrincipalExperince.css";

// Timeline data — replace with real career history
const timelineItems = [
  {
    id: 1,
    year: "Year",
    institution: "Institution",
    title: "Career Foundation",
    position: "Position",
    description: "Animated motivational Position description.",
  },
  {
    id: 2,
    year: "Year",
    institution: "Institution",
    title: "Career Growth",
    position: "Position",
    description: "Animated motivational Position description.",
  },
  {
    id: 3,
    year: "Year",
    institution: "Institution",
    title: "Career Advancement",
    position: "Position",
    description: "Animated motivational Position description.",
  },
  {
    id: 4,
    year: "Year",
    institution: "Institution",
    title: "",
    position: "",
    description: "",
  },
];

// Education data — replace with real qualifications
const educationItems = [
  {
    id: 1,
    degree: "PhD",
    subject: "English Literature",
   
  },
  {
    id: 2,
    degree: "MPhil",
    subject: "English Literature",
   
  },
  {
    id: 3,
    degree: "Master's Degree",
    subject: "English Literature",

  },
];

const ExperienceSection = () => {
  return (
    <section className="experience-section">
      <Container>
        <Row>
          <Col xs={12}>
            <h2 className="experience-heading">Experience Timeline</h2>
          </Col>
        </Row>

        <Row>
          <Col xs={12}>
            <div className="timeline-wrapper">
              {/* Top end-cap dot */}
              <Row className="timeline-cap-row">
                <Col xs={4} md={3} className="timeline-meta" />
                <Col xs={2} md={1} className="timeline-dot-col timeline-cap">
                  <span className="timeline-dot timeline-dot-small" />
                </Col>
                <Col xs={6} md={8} className="timeline-content" />
              </Row>

              {timelineItems.map((item) => (
                <Row className="timeline-item" key={item.id}>
                  <Col xs={4} md={3} className="timeline-meta">
                    <div className="timeline-year">{item.year}</div>
                    <div className="timeline-institution">
                      {item.institution}
                    </div>
                  </Col>

                  <Col xs={2} md={1} className="timeline-dot-col">
                    <span className="timeline-dot" />
                  </Col>

                  <Col xs={6} md={8} className="timeline-content">
                    {item.title && (
                      <h4 className="timeline-title">{item.title}</h4>
                    )}
                    {item.position && (
                      <p className="timeline-position">{item.position}</p>
                    )}
                    {item.description && (
                      <>
                        <p className="timeline-desc-label">Description:</p>
                        <p className="timeline-desc-text">
                          {item.description}
                        </p>
                      </>
                    )}
                  </Col>
                </Row>
              ))}

              {/* Bottom end-cap dot */}
              <Row className="timeline-cap-row">
                <Col xs={4} md={3} className="timeline-meta" />
                <Col
                  xs={2}
                  md={1}
                  className="timeline-dot-col timeline-cap timeline-cap-end"
                >
                  <span className="timeline-dot timeline-dot-small" />
                </Col>
                <Col xs={6} md={8} className="timeline-content" />
              </Row>
            </div>
          </Col>
        </Row>

        <Row>
          <Col xs={12}>
            <h2 className="education-heading">Education &amp; Qualifications</h2>
          </Col>
        </Row>

        <Row className="g-4 education-row">
          {educationItems.map((edu) => (
            <Col xs={12} md={4} key={edu.id}>
              <div className="education-card">
                <h5 className="education-degree">{edu.degree}</h5>
                <p className="education-subject">{edu.subject}</p>
                <p className="education-university">{edu.university}</p>
                <span className="education-year">{edu.year}</span>
              </div>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
};

export default ExperienceSection;